import { hasLineItems, isConfirmed, isReturn } from '../../../functions/sale'
import { ReduxCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'

export const isPromotionDisabled = (
  hasActiveSale: boolean,
  hasActivePromotions: boolean,
  currentSale: ReduxCurrentSale
) => {
  return Boolean(
    !hasActiveSale ||
      !hasActivePromotions ||
      !hasLineItems(currentSale) ||
      isReturn(currentSale) ||
      isConfirmed(currentSale) ||
      currentSale.isSavedUnfulfilled ||
      currentSale.isSavedService
  )
}
